<template>
  <div>
    <SchemaTablePage
      ref="tablePageRef"
      layout-mode="tab"
      :form-props="{ labelPosition: 'left' }"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
    >
      <template #table-header>
        <div>
          <el-button type="primary" size="mini" @click="handleAdd">新增档位</el-button>
        </div>
      </template>

      <template #colAmount="{ row }">{{ row.amountYuan != null ? row.amountYuan : '-' }}</template>
      <template #colBonusType="{ row }">{{ getBonusTypeLabel(row.bonus_type) }}</template>
      <template #colBonusFixed="{ row }">
        {{ row.bonus_type === 2 && row.bonus_fixed_amountYuan != null ? row.bonus_fixed_amountYuan : '-' }}
      </template>
      <template #colBonusRatio="{ row }">
        <span v-if="row.bonus_type === 1">
          <template v-if="row.bonus_method === 2 && row.bonus_ratio_max != null">
            {{ row.bonus_ratio_min }}% - {{ row.bonus_ratio_max }}%
          </template>
          <template v-else>
            {{ row.bonus_ratio_min != null ? row.bonus_ratio_min + '%' : '-' }}
          </template>
        </span>
        <span v-else>-</span>
      </template>
      <template #colRealMoneyAuditMultiplier="{ row }">
        {{ row.multiplier != null ? row.multiplier : '-' }}
      </template>
      <template #colBonusAuditMultiplier="{ row }">
        {{ row.bonus_multiple != null ? row.bonus_multiple : '-' }}
      </template>
      <template #colStatus="{ row }">
        <el-tag :type="row.status === 2 ? 'success' : 'info'" size="small">
          {{ row.status === 2 ? '启用' : '禁用' }}
        </el-tag>
      </template>
      <template #colActions="{ row }">
        <el-button type="text" size="small" @click="handleEdit(row)">设置</el-button>
        <el-button type="text" class="danger-button" size="small" @click="handleDelete(row)">删除</el-button>
      </template>
    </SchemaTablePage>

    <DepositTierDialog
      :visible.sync="dialogVisible"
      :mode="dialogMode"
      :edit-id="editId"
      @success="handleDialogSuccess"
    />
  </div>
</template>

<script>
import { deletePayinBonus, listPayinBonus } from '@/api/finance/payinBonus'
import { centsToYuan } from '@/utils/amount'
import DepositTierDialog from './DepositTierDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'
const BONUS_TYPE_OPTIONS = [
  { label: '比例赠送', value: 1 },
  { label: '固定金额', value: 2 },
  { label: '无赠送', value: 3 },
]
export default {
  name: 'ManageDepositTierTab',
  components: {
    DepositTierDialog,
    SchemaTablePage,
  },
  data() {
    return {
      defaultQuery: {
        status: 0,
      },
      searchSchema: [
        {
          prop: 'status',
          label: '状态',
          component: 'select',
          componentProps: { placeholder: '请选择状态', clearable: true },
          options: [
            { label: '全部', value: 0 },
            { label: '启用', value: 2 },
            { label: '禁用', value: 1 },
          ],
        },
        { component: 'actions' },
      ],
      tableColumns: [
        { type: 'index', label: '排序', width: 60, align: 'center', resizable: false },
        { prop: 'amount', label: '存款档位', minWidth: 120, resizable: false, slot: 'colAmount' },
        {
          prop: 'multiplier',
          label: '真金稽核倍数',
          minWidth: 120,
          align: 'center',
          resizable: false,
          slot: 'colRealMoneyAuditMultiplier',
        },
        { prop: 'bonus_type', label: '赠送类型', minWidth: 120, resizable: false, slot: 'colBonusType' },
        { prop: 'bonus_fixed_amount', label: '赠送金额', minWidth: 120, resizable: false, slot: 'colBonusFixed' },
        { prop: 'bonus_ratio', label: '赠送比例', minWidth: 120, resizable: false, slot: 'colBonusRatio' },
        {
          prop: 'bonus_multiple',
          label: '赏金稽核倍数',
          minWidth: 120,
          align: 'center',
          resizable: false,
          slot: 'colBonusAuditMultiplier',
        },
        { prop: 'status', label: '状态', minWidth: 90, align: 'center', resizable: false, slot: 'colStatus' },
        { width: 120, label: '操作', fixed: 'right', align: 'center', resizable: false, slot: 'colActions' },
      ],
      dialogVisible: false,
      dialogMode: 'create',
      editId: null,
    }
  },
  methods: {
    getBonusTypeLabel(bonusType) {
      return BONUS_TYPE_OPTIONS.find(item => item.value === bonusType)?.label || ''
    },
    mapRow(item) {
      return {
        ...item,
        amountYuan: item.amount != null ? centsToYuan(item.amount) : null,
        bonus_fixed_amountYuan: item.bonus_fixed_amount != null ? centsToYuan(item.bonus_fixed_amount) : null,
        // 兼容后端字段：multiplier/bonus_multiple（新） vs real_money_audit_multiplier/bonus_audit_multiplier（旧）
        multiplier: item.multiplier ?? item.real_money_audit_multiplier ?? null,
        bonus_multiple: item.bonus_multiple ?? item.bonus_audit_multiplier ?? null,
      }
    },
    request(params) {
      return listPayinBonus(params)
    },
    buildParams({ query, page, limit }) {
      const s = query?.status
      const status = s === undefined || s === null || s === '' ? 0 : s
      return {
        page,
        page_size: limit,
        status,
      }
    },
    parseResult(res) {
      const data = (res && res.data) || res || {}
      const rawList = data.list || []
      const rawTotal = data.total != null ? data.total : rawList.length
      return {
        list: Array.isArray(rawList) ? rawList.map(this.mapRow) : [],
        total: rawTotal,
      }
    },
    handleAdd() {
      this.dialogMode = 'create'
      this.editId = null
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogMode = 'edit'
      this.editId = row.id
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确定删除该档位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deletePayinBonus({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.$refs.tablePageRef?.reload?.()
        })
      })
    },
    handleDialogSuccess() {
      this.$refs.tablePageRef?.reload?.()
      this.$emit('update')
    },
  },
}
</script>

<style scoped>
.actions {
  margin-bottom: 16px;
}
</style>
